import * as React from 'react'
import { AppBarContainer } from './CustomAppBar'
import '../styles/StubComingSoon.scss'
import { StringResources } from '../localization/StringResources';
import { Strings } from '../localization';

export class StubComingSoon extends React.Component {
    render() {
        return (
            <div className="App" style={{ backgroundColor: '#ffffff' }}>
                <AppBarContainer
                    isIconButtonsShown={false}
                    isMenuShown={false}
                />
                <div className="coming-soon-stub-containter">
                    <h1>{StringResources.getString(Strings.Common.ComingSoon)}</h1>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/StubComingSoon.tsx